export class ProductStatus {
    constructor(
        public active: string = "active",
        public inactive: string = "inactive") { }
}
